import { render, staticRenderFns } from "./FormDokumen.vue?vue&type=template&id=64c24a7c&"
import script from "./FormDokumen.vue?vue&type=script&lang=js&"
export * from "./FormDokumen.vue?vue&type=script&lang=js&"
import style0 from "./FormDokumen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports